export default {
  message: {
    "error": "اوہ! کچھ غلط ہوگیا۔",
    "Sorrysomeerrorsoccurred": "ایک غیر متوقع خرابی پیش آئی۔ آپ زبان تبدیل کرنے کی کوشش کر سکتے ہیں یا ایپ کو بند کر کے دوبارہ شروع کر سکتے ہیں۔",
    "quit": "خارج ہوں",
    "language": "زبان",
    "Youcanchangethelanguagehere": "آپ یہاں زبان تبدیل کر سکتے ہیں!",
    "current": "موجودہ",
    "home": "ہوم",
    "friends": "دوست",
    "wallet": "والٹ",
    "aboutus": "ہمارے بارے میں",
    "Sharewithfriends": "دوستوں کے ساتھ شیئر کریں",
    "copyFailure": "کاپی میں ناکامی",
    "copySuccess": "کاپی کامیاب",
    "Claimreward": "انعام وصول کریں",
    "DailyLogin": "روزانہ لاگ ان",
    "noInvitationsYet": "ابھی کوئی دعوتیں نہیں",
    "LoadMore": "مزید لوڈ کریں",
    "WatchAD": "اشتہار دیکھیں",
    "continue": "جاری رکھیں",
    "Congratulations": "مبارک ہو",
    "MyFriends": "میرے دوست",
    "Invitefriends": "دوستوں کو مدعو کریں",
    "Invitepremiumfriends": "پریمیم دوستوں کو مدعو کریں",
    "DailyTasks": "روزانہ کے کام",
    "inviteDesc": "ہر دوست کے لئے +{num} ${name}",
    "DailyTasksDesc": "مزید ایئر ڈراپ حاصل کرنے کے لیے کام مکمل کریں",
    "SponsorsandPartners": "اسپانسر اور شراکت دار",
    "Receivingwallet": "وصول کرنے والا والٹ",
    "Enterwalletaddress": "والٹ کا پتہ داخل کریں {name}",
    "Claim": "انعام وصول کریں",
    "Booster": "بوسٹر",
    "RentPeriod": "کرایہ کا دورانیہ",
    "days30": "30 دن",
    "Dailyprofit": "روزانہ منافع",
    "Totalprofit": "مجموعی منافع",
    "Quantity": "مقدار",
    "RentPrice": "کرایہ کی قیمت",
    "RentMiner": "کان کن کرایہ پر لیں",
    "Insufficient": "دعوت دینے والوں کی تعداد ناکافی ہے",
    "InsufficientMsg": "آپ کو زیادہ لوازمات کمانے کے لئے {num} دوستوں کو مدعو کرنے کی ضرورت ہے۔",
    "Settings": "ترتیبات",
    "copyid": "شناخت کاپی کریں",
    "UpgradeSuccessfully": "کامیابی کے ساتھ اپ گریڈ کریں",
    "Name": "نام",
    "userinfo": "صارف کی معلومات",
    "disconnect": "منقطع کریں",
    "Startmining": "کان کنی شروع کریں",
    "Welcome": "خوش آمدید {name}",
    "Withdrawal": "نکالنا",
    "Minimumamount": "کم سے کم رقم",
    "Networkfee": "نیٹ ورک فیس",
    "Enteramount": "رقم داخل کریں",
    "Submit": "جمع کرائیں",
    "MinimumTip": "نکاسی کی رقم بہت چھوٹی ہے۔ کم از کم نکاسی کی رقم: {num}",
    "MaximumTip": "رقم ناکافی ہے، آپ زیادہ سے زیادہ {num} رقم نکال سکتے ہیں",
    "SubmittedTip": "جمع کرایا گیا، متوقع ہے کہ 30-60 کاروباری دنوں میں پروسیس ہو جائے گا",
    "WebSubmittedTip": "جمع کرایا گیا، ہم اسے جتنا جلدی ہو سکے پروسیس کریں گے۔",
    "WithdrawStatus": "حالت",
    "Submissiontime": "جمع کرانے کا وقت",
    "WithdrawAwaitTip": "* اس میں 30-60 کاروباری دن لگنے کی توقع ہے۔ مزید دوستوں کو مدعو کرنے سے جائزہ لینے کے عمل کی رفتار بڑھ سکتی ہے۔",
    "WebWithdrawAwaitTip": "* اس میں 24-48 گھنٹے لگنے کی توقع ہے۔ مزید دوستوں کو مدعو کرنے سے جائزہ لینے کے عمل کی رفتار بڑھ سکتی ہے۔",
    "Processing": "پروسیسنگ",
    "Success": "کامیابی",
    "Rejection": "رد",
    "Amount": "رقم",
    "Numberoffriends": "دوستوں کی تعداد: {now}/{limit}",
    "InviteTip": "اپنی پہلی نکاسی کے لیے، آپ کو {limit} دوستوں کو مائننگ ایپ میں شامل ہونے کی دعوت دینا ہوگی۔",
    "openonphone": "اس لنک کو اپنے فون پر کھولیں۔",
    "claimTip": "جو رقم وصول کی جانی ہے وہ بہت چھوٹی ہے۔ کم از کم وصول کی جانے والی رقم: {num}",
    "WalletBalance": "والٹ بیلنس",
    "Withdraw": "نکالیں",
    "SetWalletAddress": "والٹ کا پتہ مرتب کریں",
    "WithdrawalRecord": "نکاسی کا ریکارڈ",
    "Norecords": "کوئی ریکارڈ نہیں",
    "Whatis": "{name} کیا ہے؟",
    "All": "سب",
    "save": "محفوظ کریں",
    "successWithdrawal": "اسکین کامیاب {num}",
    "secondsago": "{time} سیکنڈ پہلے",
    "Loading": "لوڈ ہو رہا ہے...",
    "PaymentConfirming": "ٹرانزیکشن کی حالت چیک کر رہا ہے...",
    "Check": "چیک کریں",
    "CheckFail": "ٹرانزیکشن مکمل نہیں ہوئی۔ براہ کرم 5 سیکنڈ بعد دوبارہ چیک کریں۔",
    "Addname": "'{name}' کو اپنے نام میں شامل کریں",
    "Restattcheck": "چیک کرنے کے لیے ایپ کو دوبارہ شروع کریں",
    "Copyname": "'{name}' کاپی کریں",
    "SubmissionFailed": "جمع کرانا ناکام ہو گیا، براہ کرم بعد میں دوبارہ کوشش کریں",
    "WithdrawalReview": "نکاسی کا جائزہ",
    "select_payment_method": "ادائیگی کا طریقہ منتخب کریں",
    "total_amount": "کل رقم",
    "next_step": "اگلا مرحلہ",
    "creating_order": "آرڈر بنا رہے ہیں...",
    "order_created": "آرڈر بنایا گیا",
    "order_status": "آرڈر کی حالت",
    "order_id": "آرڈر آئی ڈی",
    "order_amount": "آرڈر کی رقم",
    "order_status_desc": "آرڈر کی حالت کی وضاحت",
    "payment_cancelled": "ادائیگی منسوخ کر دی گئی",
    "opening_payment": "ادائیگی کھول رہے ہیں...",
    "payment_success": "ادائیگی کامیاب",
    "payment_failed": "ادائیگی ناکام",
    "payment_pending": "ادائیگی زیر التواء",
    "payment_processing": "ادائیگی کی پروسیسنگ",
    "create_order_failed": "آرڈر بنانا ناکام",
    "creating_ton_order": "TON آرڈر بنا رہے ہیں...",
    "check_payment_status": "ادائیگی کی حالت چیک کر رہے ہیں...",
    "use_ton_payment": "TON ادائیگی استعمال کریں",
    "connect_wallet": "والٹ منسلک کریں",
    "start_transaction": "Transaction شروع کریں",
    "address": "پتہ",
    "amount_ton": "رقم TON",
    "copy": "کاپی کریں",
    "comment_memo": "تبصرہ میمو",
    "comment_memo_desc": "براہ کرم تبصرہ میمو درج کریں",
    "comment_memo_placeholder": "تبصرہ میمو درج کریں",
    "amount": "رقم",
    "wallet_address": "والٹ پتہ",
    "you_can_choose_to_connect_wallet_to_pay": "آپ ادائیگی کے لیے والٹ منسلک کرنے کا انتخاب کر سکتے ہیں",
    "or_manually_transfer_to_the_above_address": "یا اوپر دیے گئے پتے پر دستی طور پر منتقل کریں (نوٹ کریں کہ رقم اور میمو عین ایک جیسے ہونے چاہئیں)",
    "transaction_success": "ٹرانزیکشن کامیاب",
    "transaction_failed": "ٹرانزیکشن ناکام",
    "transaction_error": "ٹرانزیکشن کی خرابی",
    "transaction_status": "ٹرانزیکشن کی حیثیت",
    "transaction_id": "ٹرانزیکشن ID",
    "transaction_amount": "ٹرانزیکشن کی رقم",
    "transaction_status_desc": "ٹرانزیکشن کی حیثیت کی وضاحت",
    "miner_detail": "مائنر کی تفصیل",
    "rent_period": "کرایہ کی مدت",
    "days": "{days} دن",
    "daily_yield": "روزانہ کی پیداوار",
    "total_yield": "کل پیداوار",
    "invite_friends": "دوست مدعو کریں",
    "price": "قیمت",
    "rent": "کرایہ",
    "free_claim": "مفت انعام جمع کریں",
    "redeem": "انعام حاصل کریں",
    "buy": "کرایہ",
    "invite_friends_not_enough": "دوستوں کو مدعو کرنے کے لیے کافی نہیں",
    "redeem_success": "انعام حاصل کرنا کامیاب",
    "redeem_failed": "انعام حاصل کرنا ناکام",
    "rent_success": "کرایہ کامیاب",
    "rent_failed": "کرایہ ناکام",
    "TotalPower": "کل طاقت",
    "MaxQuantity": "زیادہ سے زیادہ قیمت تک پہنچ گیا",
    "Running": "چل رہا ہے",
    "Stop": "روکیں",
    "Withdrawalunlock": "نکاسی انلاک کرنا",
    "Close": "بند کریں",
    "Delivering": "پہنچا رہے ہیں",
    "Duetothelargenumber": "موصول کنندگان کی بڑی تعداد کی وجہ سے، آپ کا ایئر ڈراپ 15-20 کاروباری دنوں میں آنے کی توقع ہے",
    "WithdrawalunlockTip": "آپ کو نکاسی کو انلاک کرنے کے لیے {num} مدعو کردہ دوستوں کی ضرورت ہے تاکہ ٹاسک مکمل ہوں/والٹ بند ہوں",
    "mining_title": "روبوٹ",
    "Upgrade": "اپ گریڈ کریں",
    "partner": "پارٹنر",
    "faq": "عمومی سوالات",
    "task": "کام",
    "OpenRobot": "روبوٹ کھولیں",
    "MyRobot": "میرا روبوٹ",
    "Level": "لیول",
    "Commission": "کمیشن",
    "DirectFriends": "براہ راست دوست",
    "Feedback": "فیڈبیک",
    "Pleaseenteryouremailaddress": "براہ کرم اپنا ای میل ایڈریس درج کریں",
    "Inputfeedbackcontent": "فیڈبیک کا مواد درج کریں",
    "Submitfeedback": "فیڈبیک جمع کرائیں",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "فیڈبیک کامیابی سے جمع کرایا گیا، آپ کی قیمتی رائے کا شکریہ",
    "Feedbacksubmissionfailed,pleaseretriy": "فیڈبیک جمع کرنے میں ناکامی، براہ کرم دوبارہ کوشش کریں",
    "Addressformaterror": "پتہ کے فارمیٹ میں خرابی",
    "Readclipboardfailed": "کلپ بورڈ کو پڑھنے میں ناکامی",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "آپ نے آج پہلے ہی فیڈبیک دیا ہے، براہ کرم کل واپس آئیں",
    "Record": "ریکارڈ",
    "Newuserguidance": "خوش آمدید ٹور دیکھیں",
    "Usetonwallet": "TON والٹ کا استعمال کریں",
    "Reward": "انعام",
    "Connectwallet": "والٹ سے جڑیں",
    "Notconnected": "کنیکٹ نہیں ہے",
    "Disconnect": "کنکشن منقطع کریں",
    "AboutTAI": "ٹوکن کی تفصیلات",
    "WithdrawalRecordDesc": "واپسی کا ریکارڈ",
    "StartAItrading": "AI تجارت شروع کریں",
    "Next": "اگلا",
    "Start": "شروع کریں",
    "WithdrawalSuccess": "واپسی کامیاب",
    "WithdrawalFail": "واپسی ناکام",
    "Max": "زیادہ سے زیادہ",
    "WithdrawalRecords": "واپسی کے ریکارڈ",
    "Commissionrules": "کمیشن کے اصول",
    "Mycommission": "میرا کمیشن",
    "Shop": "شاپ",
    "BuyDifferentAIrobots": "تیز اسکینز کے لئے کمپیوٹ ڈیوائسز کے ساتھ اپ گریڈ کریں!",
    "CurrentRunningAIrobots": "موجودہ فعال AI روبوٹس",
    "DailyProfit": "روزانہ کا منافع",
    "Buy": "خریدें",
    "ValidityPeriod": "میت کی مدت",
    "Days": "دن",
    "Price": "قیمت",
    "APY": "APY",
    "NoRobot": "کوئی کمپیوٹ پاور نہیں",
    "RemainingTime": "باقی وقت",
    "InviteandEarn": "مدعو کریں اور کمائیں",
    "InvitDec": "اپنے دوستوں کو AI تجارت میں شامل ہونے کے لیے مدعو کریں اور USDT کمیشن اور ایئر ڈراپ ٹوکن مل کر کمائیں!",
    "ShareToGroups": "گروپس میں شیئر کریں",
    "Select_payment_method": "ادائیگی کا طریقہ منتخب کریں",
    "twa_pay_tip_with_memo": "براہ کرم یقینی بنائیں کہ پتہ، رقم، اور یادداشت منتقلی کے لیے ہم آہنگ ہیں۔",
    "twa_pay_tip": "براہ کرم یقینی بنائیں کہ پتہ اور رقم منتقلی کے لیے درست ہیں۔",
    "twa_pay_tip_placeholder": "تبصرہ یادداشت درج کریں",
    "twa_pay_tip_placeholder_with_memo": "یادداشت کے ساتھ تبصرہ یادداشت درج کریں",
    "twa_pay_tip_placeholder_without_memo": "یادداشت کے بغیر تبصرہ یادداشت درج کریں",
    "twa_pay_tip_placeholder_with_memo_placeholder": "یادداشت کے ساتھ تبصرہ یادداشت درج کریں",
    "twa_pay_tip_placeholder_without_memo_placeholder": "یادداشت کے بغیر تبصرہ یادداشت درج کریں",
    "realtime_ai": "حقیقی وقت کی AI تجارت",
    "check_transaction_status": "لین دین کی حیثیت چیک کریں",
    "transaction_wait": "لین دین کی کارروائی ہو رہی ہے۔ آپ ایپ کو بند کر سکتے ہیں۔ آپ کو ایک پیغام موصول ہوگا جب یہ مکمل ہو جائے گا۔",
    "Pleaseenteravalidemailaddress": "براہ کرم ایک درست ای میل پتہ درج کریں",
    "max_robot_tip": "خریداری کی حد تک پہنچ گئی — تجارت جاری رکھنے کے لیے کوئی اور منصوبہ آزما لیں!",
    "connectFailure": "والٹ کنیکٹ کرنے میں ناکامی",
    "connectSuccess": "والٹ کنیکٹ کرنے میں کامیابی",
    "PayNow": "اب ادائیگی کریں",
    "min_withdrawal_amount": "کم از کم واپسی کی رقم ہے {num} {coin_name}",
    "max_withdrawal_amount": "زیادہ سے زیادہ واپسی کی رقم ہے {num} {coin_name}",
    "balance_not_enough": "آپ کے پاس اس واپسی کے لیے کافی بیلنس نہیں ہے۔",
    "Numberofgroups": "گروپوں کی تعداد: {now}/{limit}",
    "Withdraw_success": "واپسی کامیاب",
    "allProfit": "کل منافع",
    "AnnualProfit": "سالانہ منافع",
    "ScanWallet": "والٹ اسکین کریں",
    "wallet_check": "والٹ_چیک",
    "Found": "مل گیا",
    "ScanSpeed": "اسکین کی رفتار",
    "MyComputingPower": "کمپیوٹ",
    "Scanning": "اسکیننگ!",
    "WithdrawDetail": "نکلوانے کی تفصیلات",
    "ScanSuccess": "آپ کی اسکین کامیابی کی شرح بڑھ گئی ہے!",
    "TaskDescription": "کام مکمل کریں تاکہ آپ کی اسکین کامیابی کی شرح میں اضافہ ہو!",
    "InitializingMiningSystem": "اسکین سسٹم شروع ہو رہا ہے...",
    "NoWithdrawalRecord": "کوئی واپسی کا ریکارڈ نہیں",
    "Invite": "ضروری دعوتیں",
    "Free": "مفت",
    "Confirm": "تصدیق کریں",
    "RefreshTasks": "کام دوبارہ لو",
    "NumberofGroups": "گروپوں کی تعداد: {now}/{limit}",
    "SendMessage": "پیغام بھیجیں",
    "NumberofShares": "شیئرز کی تعداد: {now}/{limit}",
    "NumberofTasks": "اسائنمنٹس کی تعداد: {now}/{limit}",
    "CompleteTask": "اسائنمنٹ مکمل کریں",
    "Accelerated": "تیز",
    "Accelerated_withdrawals_success": "تیز واپسی کامیابی سے",
    "GoBuy": "خریداری کریں",
    "SpeedUpScan": "تیز کریں",
    "Earnings": "کمائی",
    "learnMore": "زیادہ جانیں",
    "claimSuccess": "انعامات وصول کر لیے گئے",
    "claimFailed": "وصولی ناکام، براہ کرم دوبارہ کوشش کریں",
    "noDividends": "وصول کرنے کے لیے کوئی منافع نہیں",
    "dividendsInfoFallback": "دوستوں کو مدعو کریں تاکہ ریفرل انعامات حاصل کر سکیں"
}};